import { __generator } from "tslib";
import { all, call, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { request } from '../../xhr';
import { fakeResponse } from './fakeResponse';
import { unsuggestUser } from './actions';
var logger = ddt.createLogger('suggestions');
function postRequest(url, data) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: url,
                    data: data,
                }, fakeResponse(url))];
            case 1:
                response = _a.sent();
                logger.log('POST:response', response);
                return [2 /*return*/, response];
        }
    });
}
function handleUnsuggestUser(action) {
    var data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = action.payload;
                return [4 /*yield*/, call(postRequest, 'watch/unsuggest', data)];
            case 1:
                response = _a.sent();
                if (!response || !response.success) {
                    logger.error(response.errorDescription);
                    return [2 /*return*/];
                }
                return [2 /*return*/];
        }
    });
}
export default function userRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeEvery(unsuggestUser, handleUnsuggestUser)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map